import React, { Component } from 'react';
import { NavBar } from '../NavBar/NavBar';
import { Footer } from '../Footer/Footer';
import '../Themes/theme.css';

export class CustomLayout extends Component {
    static displayName = CustomLayout.name;

    render() {
        return (
            <div className='layout-container'>
                <NavBar componentId={1} />
                {this.props.children}
                <Footer componentId={1} />
            </div>
        );
    }
}
